import React from 'react';
import PropTypes from 'prop-types';

import { AnalyticsListener, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

import { EmbeddedConfluenceSource } from './EmbeddedConfluenceSource';

const eventTypes = [
	'sendOperationalEvent',
	'sendPageEvent',
	'sendTrackEvent',
	'sendUIEvent',
	'sendScreenEvent',
];

export class ConfluenceAnalyticsListener extends React.Component<React.PropsWithChildren<{}>> {
	static propTypes = {
		children: PropTypes.any.isRequired,
	};

	sendAnalyticEvents(event: UIAnalyticsEvent) {
		if (!event || !event.payload) {
			throw new Error('Analytics Web Client Payload is required');
		} else if (!eventTypes.includes(event.payload.type)) {
			throw new Error(`Recieved Unknown Type for Analytics Web Client: ${event.payload.type}`);
		}
		void getAnalyticsWebClient().then((analyticWebClientResponse) => {
			analyticWebClientResponse[event.payload.type](event.payload.data);
		});
	}
	render() {
		return (
			<AnalyticsListener onEvent={this.sendAnalyticEvents}>
				<EmbeddedConfluenceSource>{this.props.children}</EmbeddedConfluenceSource>
			</AnalyticsListener>
		);
	}
}
